

<div class="page-layout simple fullwidth inner-scroll mat-white-bg" aria-labelledby="mindmap-editor-title" fusePerfectScrollbar>

  <div class="content">
    @if (isLoadingDone) {
      <div class="content-editor">
        <div class="mindmap-header" id="mindmap-editor-title">
          <div>{{mindmapTitle}}</div>
          <button class="close"
            (click)="close()"
            [attr.aria-label]="'generic.close' | translate"
            [matTooltip]="'generic.close' | translate">
            <mat-icon svgIcon="cross"></mat-icon>
          </button>
        </div>
        <div class="mindmap-content">
          <iframe [src]="urlToMindmap" [attr.title]="'accesibility.mindmap_title' | translate" height="100%" width="100%"></iframe>
        </div>
      </div>
    } @else {
      <mat-spinner></mat-spinner>
    }
  </div>
</div>
